import { render, staticRenderFns } from "./SectionCarryMaterial.vue?vue&type=template&id=1d497717&scoped=true"
import script from "./SectionCarryMaterial.vue?vue&type=script&lang=js"
export * from "./SectionCarryMaterial.vue?vue&type=script&lang=js"
import style0 from "./SectionCarryMaterial.vue?vue&type=style&index=0&id=1d497717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d497717",
  null
  
)

export default component.exports